import { ProgressBar } from '@arcadiapower/shrike';
import { TwoColumnGrid } from '~/components/layout';
import { Title, Description } from '~/components/typography';
import { useCopy } from '~/hooks';

export const PaymentVerification = () => {
  const copy = useCopy({}, defaultCopy);
  return (
    <TwoColumnGrid testId="screen-PaymentHold">
      <TwoColumnGrid.Primary>
        <Title>{copy.pending.title}</Title>
        <Description>{copy.pending.description}</Description>
        <ProgressBar data-testid="progress-bar" automatic secondsToProgress={15} />
      </TwoColumnGrid.Primary>
    </TwoColumnGrid>
  );
};

export const defaultCopy = () => ({
  pending: {
    title: 'Verifying your payment method...',
    description: 'Please wait, this could take a few moments.',
  },
});
